/**
 * Generic env string parsing for QC pages (comma-separated positive numbers, etc.).
 */

/**
 * Parses a comma-separated list of positive numbers from an env string.
 * Returns `fallback` when the string is empty OR when parsing yields no valid
 * positive numbers (previously returned `[]` in the latter case, which could
 * produce an empty page-size dropdown).
 *
 * @param {string | undefined} value - Raw env value.
 * @param {number[]} fallback - Used when the string is empty or yields no valid numbers.
 * @returns {number[]}
 */
export function parseEnvNumberList(value, fallback) {
  const fb = Array.isArray(fallback) ? fallback : [];
  let raw = '';
  try {
    raw = (value ?? '').toString().trim();
  } catch {
    return fb;
  }
  if (!raw) return fb;
  const parsed = raw
    .split(',')
    .map((v) => Number(v.trim()))
    .filter((n) => Number.isFinite(n) && n > 0);
  return parsed.length > 0 ? parsed : fb;
}
